/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import {ResponseData, showDialog, showSnackbar} from '@dvrd/dvr-controls';
import React, {useEffect, useRef, useState} from 'react';
import Connection from '../../../models/connectionModel';
import {getMaintenanceMode} from '../../../util/maintenanceUtil';
import {toggleMaintenanceMode} from '../../../util/requestSender';
import AdminConnections from './adminConnections';

const PING_TIMEOUT = 300000; // Every 5 minutes

export default function AdminConnectionsController() {
    const pingTimeout = useRef<undefined | number>(undefined);
    const [connections, setConnections] = useState<Array<Connection>>([]);
    const [loading, setLoading] = useState(false);

    function onToggleMaintenance(value: boolean) {
        const currentMode = getMaintenanceMode();
        const action = value ? 'inschakelen' : 'uitschakelen';
        showDialog(`Weet je zeker dat je de onderhoudsmodus wilt ${action}?`, 'Bevestig',
            [{label: 'Nee', primary: !currentMode},
                {label: 'Ja', onClick: onConfirmToggleMaintenance(value), primary: currentMode}]);
    }

    function onConfirmToggleMaintenance(value: boolean) {
        return function () {
            setLoading(true);
            toggleMaintenanceMode({
                data: {toggled: value}, callback: (data: ResponseData) => {
                    setLoading(false);
                    const action = value ? 'ingeschakeld' : 'uitgeschakeld';
                    if (data.success) {
                        showSnackbar(`Onderhoud modus is ${action}, de pagina wordt opnieuw geladen`);
                        window.setTimeout(() => {
                            window.location.reload();
                        }, 2000);
                    } else showDialog(data.message ?? 'Het wijzigen van de onderhoudsmodus is niet gelukt.');
                }
            });
        };
    }

    function getConnections() {
        Connection.getAll((connections: Connection[], success: boolean) => {
            if (success) setConnections(connections);
        });
        pingTimeout.current = window.setTimeout(getConnections, PING_TIMEOUT);
    }

    useEffect(() => {
        getConnections();
        return function () {
            window.clearTimeout(pingTimeout.current);
            pingTimeout.current = undefined;
        };
    }, []);

    return (
        <AdminConnections onToggleMaintenance={onToggleMaintenance} connections={connections} loading={loading}/>
    );
}